import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BlogBox = ({ className = '', limit = null }) => {
  const { t } = useTranslation();
  const blogs = [
    {
      title: t('sections.blogBox.blogs.0.title','Top Cybersecurity Trends to Watch in 2024 See Overview'),
      img: 'assets/img/blog/blog_2_1.jpg',
      date: 'January 26',
      detailsLink: "/blog/top-cybersecurity-trends-2024",
    },
    {
      title: t('sections.blogBox.blogs.1.title','AI in Cybersecurity: A Double-Edged You Ever Find Sword?'),
      img: 'assets/img/blog/blog_2_2.jpg',
      date: 'March 05',
      detailsLink: "/blog/ai-in-cybersecurity", 
    },
    {
      title: t('sections.blogBox.blogs.2.title','The Importance of Regular Security Audits'),
      img: 'assets/img/blog/blog_1_3.jpg',
      date: 'April 15',
      detailsLink: "/blog/strong-password-guide",
    },
  ];

  const displayedBlogs = limit ? blogs.slice(0, limit) : blogs;
  const currentYear = new Date().getFullYear();

  return (
    <>
      {displayedBlogs.map((blog, index) => (
        <div className={className} key={index}>
          <div className="blog-card" data-cue="slideInUp">
            <div className="blog-img">
              <img src={blog.img} alt={blog.title} />
            </div>
            <div className="blog-content">
              <div className="blog-meta">
                <Link to="/blog">{blog.date}, {currentYear}</Link>
              </div>
              <h3 className="box-title">
                <Link to={blog.detailsLink}>{blog.title}</Link>
              </h3>
              <Link to={blog.detailsLink} className="link-btn style-gradient">
                {t('sections.blogBox.read_more','Read More')}<i className="far fa-long-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlogBox;